(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/dialogs.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/dialogs.js');

'use strict';

const mobileConfirmedSuccessTitle = "Mobilnummer bekr\xE4ftat!";
const mobileConfirmedSuccessMessage = 'Nytt mobilnummer: ';
const showSettingsTechnicalError = function () {
  let text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'För tillfället upplever vi tekniska problem. Alla inställningar är inte tillgängliga just nu. Vänligen försök igen senare.';
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Tekniskt fel',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text
    }],
    actions: [{
      title: 'Okej'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showNotLoggedInError = () => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Du är inte inloggad',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Vänligen logga in och försök igen'
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        svs.core.userSession.logout();
        svs.utils.url.navigate("".concat(svs.core.urlMapping.get('loginHome'), "?returnUrl=").concat(svs.utils.url.currentPathEncodedParams()));
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showCustomersOldLinkError = () => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    title: 'Tekniskt fel',
    type: svs.ui.dialog.type.ERROR,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Du har använt en gammal eller felaktig länk. Logga in för att ändra dina kommunikationsval.'
    }],
    actions: [{
      title: 'Okej',
      callback() {
        svs.utils.url.navigate("".concat(svs.core.urlMapping.get('loginHome'), "?returnUrl=").concat(svs.utils.url.currentPathEncodedParams()));
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showBaseError = function (title, text) {
  let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        callback();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showTechnicalError = function () {
  let text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'För tillfället upplever vi tekniska problem. Vänligen försök igen senare.';
  let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  showBaseError('Tekniskt fel', text, callback);
};
const showHandledError = function (text) {
  let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  showBaseError('Ett fel har uppstått', text, callback);
};
const showMobileConfirmedFlash = cellphone => {
  svs.core.flash(svs.ui.dialog.type.SUCCESS, {
    title: mobileConfirmedSuccessTitle,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: mobileConfirmedSuccessMessage + cellphone
    }],
    branding: svs.ui.dialog.branding.TUR,
    area: svs.ui.dialog.area.POPUP,
    icon: 'thumbs-up'
  });
};
const showMobileConfirmedDialog = (cellphone, callback) => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'thumbs-up',
    branding: svs.ui.dialog.branding.TUR,
    title: mobileConfirmedSuccessTitle,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: mobileConfirmedSuccessMessage + cellphone
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        callback();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showMobileVerificationCodeSent = cellphone => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'checkmark',
    autoClose: svs.ui.dialog.autoClose.MEDIUM,
    branding: svs.ui.dialog.branding.TUR,
    title: "SMS med bekr\xE4ftelsekod har skickats till: ".concat(cellphone),
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showOrderTranscriptError = text => {
  const dialog = new svs.ui.dialog.Confirm({
    title: 'Ett problem har uppstått',
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: text || 'Ett fel har inträffat vid beställning av utdrag. Försök igen lite senare och om felet kvarstår, kontakta Kundservice.'
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showAboutTranscript = () => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'document',
    branding: svs.ui.dialog.branding.TUR,
    title: "Om registerutdrag",
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: "Enligt dataskyddsf\xF6rordningens artikel 15 har du r\xE4tt att f\xE5 information om bland annat vilka personuppgifter som f\xF6r n\xE4rvarande behandlas \n        om dig som kund samt \xE4ndam\xE5len med behandlingen."
    }, {
      type: svs.ui.dialog.message.TEXT,
      text: "Vill du l\xE4sa mer om hur vi behandlar dina personuppgifter se <a href=\"".concat(svs.core.urlMapping.get('termsIntegrityPersonData'), "\">\n        AB Svenska Spels information om behandling av personuppgifter.</a>")
    }],
    actions: [{
      title: 'Stäng',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
svs.myProfile.react.shared.dialogs = {
  showCustomersOldLinkError,
  showSettingsTechnicalError,
  showNotLoggedInError,
  showTechnicalError,
  showMobileConfirmedFlash,
  showMobileConfirmedDialog,
  showMobileVerificationCodeSent,
  showHandledError,
  showBaseError,
  showOrderTranscriptError,
  showAboutTranscript
};

 })(window);